module.exports = __webpack_public_path__ + "img/warning-embargo-detail.a7aefe62.svg";